// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.rdp-root {
  font-family: "Bosch Sans", sans-serif;
}

.rdp-root {
  display: flex;
  --rdp-accent-color: none;
  justify-content: center;
  align-items: center;
  z-index: 999;
  position: relative;
  margin-top: -20px;
}

.rdp-root > div {
  background-color: #ffffff;
  padding-bottom: 15px;
  margin-top: 20px;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  overflow: visible;
  width: 277px;
}

.css-yd8sa2 {
  gap: 0px !important;
}

.rdp-months {
  display: flex;
  justify-content: center;

  max-width: none;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.25);
}

.rdp-chevron {
  fill: #000000;
  margin: -10px 20px 0 0;
  width: 19px;
}

th.rdp-weekday {
  font-weight: 700;
  color: #000000;
  font-size: 12px;
}

button.rdp-day_button {
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.rdp-range_end .rdp-day_button,
.rdp-range_start .rdp-day_button {
  color: #ffffff;
  background-color: #007bc0;
  border-radius: 0px;
  border: none;
}

.rdp-range_start,
.rdp-range_end {
  background: transparent !important;
}

.rdp-day_button {
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 2.77em;
  height: 2em;
  font-weight: normal !important;
  font-size: 12px;
}

.rdp-range_middle {
  background-color: #d0d4d8;
  margin-bottom: 10px;
}

.rdp-nav {
  margin: 5px 13.2px 0px 0px !important;
}

.rdp-button_previous,
.rdp-button_next {
  display: inline-block;
  background-color: transparent;
  border: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.rdp-button_previous img,
.rdp-button_next img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.rdp-month_caption {
  display: flex;
  justify-content: center;
  align-items: center;
}

.rdp-button_previous.active {
  pointer-events: auto;
  opacity: 1;
}

.rdp-button_next {
  pointer-events: auto;
  opacity: 1;
}

.rdp-month_caption .rdp-caption_label {
  font-size: 14px;
  font-weight: bold;
}

.rdp-day_selected .rdp-day_button,
.rdp-day_selected:focus .rdp-day_button,
.rdp-day_selected:hover .rdp-day_button {
  font-weight: normal !important;
}

.rdp-day {
  height: 0px !important;
  width: 0px !important;
}

& .MuiInputBase-input {
  transform: none;
}

.calendar-full-width .MuiFilledInput-root {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/componentes/calendarInput/calendarInput.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;;EAEvB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["div.rdp-root {\n  font-family: \"Bosch Sans\", sans-serif;\n}\n\n.rdp-root {\n  display: flex;\n  --rdp-accent-color: none;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  position: relative;\n  margin-top: -20px;\n}\n\n.rdp-root > div {\n  background-color: #ffffff;\n  padding-bottom: 15px;\n  margin-top: 20px;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  overflow: visible;\n  width: 277px;\n}\n\n.css-yd8sa2 {\n  gap: 0px !important;\n}\n\n.rdp-months {\n  display: flex;\n  justify-content: center;\n\n  max-width: none;\n  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.25);\n}\n\n.rdp-chevron {\n  fill: #000000;\n  margin: -10px 20px 0 0;\n  width: 19px;\n}\n\nth.rdp-weekday {\n  font-weight: 700;\n  color: #000000;\n  font-size: 12px;\n}\n\nbutton.rdp-day_button {\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n}\n\n.rdp-range_end .rdp-day_button,\n.rdp-range_start .rdp-day_button {\n  color: #ffffff;\n  background-color: #007bc0;\n  border-radius: 0px;\n  border: none;\n}\n\n.rdp-range_start,\n.rdp-range_end {\n  background: transparent !important;\n}\n\n.rdp-day_button {\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  width: 2.77em;\n  height: 2em;\n  font-weight: normal !important;\n  font-size: 12px;\n}\n\n.rdp-range_middle {\n  background-color: #d0d4d8;\n  margin-bottom: 10px;\n}\n\n.rdp-nav {\n  margin: 5px 13.2px 0px 0px !important;\n}\n\n.rdp-button_previous,\n.rdp-button_next {\n  display: inline-block;\n  background-color: transparent;\n  border: none;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n}\n\n.rdp-button_previous img,\n.rdp-button_next img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.rdp-month_caption {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rdp-button_previous.active {\n  pointer-events: auto;\n  opacity: 1;\n}\n\n.rdp-button_next {\n  pointer-events: auto;\n  opacity: 1;\n}\n\n.rdp-month_caption .rdp-caption_label {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.rdp-day_selected .rdp-day_button,\n.rdp-day_selected:focus .rdp-day_button,\n.rdp-day_selected:hover .rdp-day_button {\n  font-weight: normal !important;\n}\n\n.rdp-day {\n  height: 0px !important;\n  width: 0px !important;\n}\n\n& .MuiInputBase-input {\n  transform: none;\n}\n\n.calendar-full-width .MuiFilledInput-root {\n  width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
